import { DEFAULT_THEME } from "../../../themes/defaultTheme";
import merge from 'lodash/merge';
import { getBaseThemeOptions } from "./getBaseThemeOptions";
export var buildThemeOptions = function buildThemeOptions(options) {
  var _options$palette, _palette$type, _baseThemeOptions$pal, _baseThemeOptions$pal2;

  var palette = (_options$palette = options == null ? void 0 : options.palette) != null ? _options$palette : {};
  var acidTheme = (_palette$type = palette == null ? void 0 : palette.type) != null ? _palette$type : DEFAULT_THEME;
  var baseThemeOptions = getBaseThemeOptions(acidTheme);
  var muiThemeType = (_baseThemeOptions$pal = baseThemeOptions == null ? void 0 : (_baseThemeOptions$pal2 = baseThemeOptions.palette) == null ? void 0 : _baseThemeOptions$pal2.type) != null ? _baseThemeOptions$pal : 'light';
  var muiThemeOptions = merge(baseThemeOptions, options != null ? options : {});
  if (!muiThemeOptions.palette) muiThemeOptions.palette = {};
  muiThemeOptions.palette.type = muiThemeType;
  return muiThemeOptions;
};